import { Trans, useTranslation } from 'react-i18next';

import { Link, Stack, Typography } from '@mui/material';

import { i18nNS } from '../../../i18n';
import WebIcon from '../../../icons/WebIcon';
import useNoClasses, { UseNoClassesProps } from './vm';

export interface NoClassesProps extends UseNoClassesProps {
  className?: string;
}

const NoClasses = ({ className, ...vmProps }: NoClassesProps) => {
  const { t } = useTranslation([i18nNS.CLASS]);

  const { acadlyWebTimelineUrl } = useNoClasses(vmProps);

  return (
    <Stack justifyContent="center" alignItems="center" className={className}>
      <Stack alignItems="center" gap={2}>
        <WebIcon size={48} color="grey.300" />
        <Stack gap={4} width={270}>
          <Typography variant="h6Medium" component="p" textAlign="center">
            {t('no_classes_are_scheduled_in_which_you_re_a_class_in_charge', { ns: i18nNS.CLASS })}
          </Typography>
          <Typography variant="h6Medium" component="p" textAlign="center">
            <Trans
              t={t}
              ns={i18nNS.CLASS}
              i18nKey="click_here_to_launch_acadly_s_web_application_and_create_a_class"
            >
              Click{' '}
              <Link href={acadlyWebTimelineUrl} target="_blank">
                here
              </Link>{' '}
              to launch Acadly's web application and create a class
            </Trans>
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default NoClasses;
